import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { TargetIcon, HeartIcon, TrophyIcon, UsersIcon, TruckIcon, ShieldCheckIcon, SendIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function AboutPage() {
  const stats = [{
    value: '5+',
    label: 'років на ринку'
  }, {
    value: '3000+',
    label: 'задоволених клієнтів'
  }, {
    value: '500+',
    label: 'встановлених басейнів'
  }, {
    value: '24/7',
    label: 'підтримка в Telegram'
  }];
  const values = [{
    icon: TargetIcon,
    title: 'Якість',
    description: 'Працюємо тільки з перевіреними брендами та надаємо офіційну гарантію на всі товари'
  }, {
    icon: HeartIcon,
    title: 'Турбота про клієнта',
    description: 'Допомагаємо з вибором, консультуємо та супроводжуємо на кожному етапі'
  }, {
    icon: TrophyIcon,
    title: 'Професіоналізм',
    description: 'Наші спеціалісти мають багаторічний досвід роботи з басейнами та саунами'
  }];
  return <main className="min-h-screen bg-slate-50" data-id="element-351">
      {/* Breadcrumbs */}
      <div className="bg-white border-b border-slate-100" data-id="element-352">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-353">
          <nav className="flex items-center gap-2 text-sm" data-id="element-354">
            <Link to="/" className="text-slate-500 hover:text-slate-700" data-id="element-355">
              Головна
            </Link>
            <span className="text-slate-300" data-id="element-356">/</span>
            <span className="text-slate-900 font-medium" data-id="element-357">Про компанію</span>
          </nav>
        </div>
      </div>

      {/* Hero */}
      <section className="bg-gradient-to-br from-slate-900 via-slate-800 to-sky-900 text-white py-20" data-id="element-358">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-359">
          <div className="max-w-3xl" data-id="element-360">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="text-4xl lg:text-5xl font-bold mb-6" data-id="element-361">
              Aqua Pools — ваш партнер у світі басейнів та саун
            </motion.h1>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="text-xl text-slate-300 leading-relaxed" data-id="element-362">
              Ми допомагаємо створювати простір для відпочинку та релаксації.
              Від підбору обладнання до професійного монтажу — ми поруч на
              кожному етапі.
            </motion.p>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-12 bg-white" data-id="element-363">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-364">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-365">
            {stats.map((stat, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} className="text-center" data-id="element-366">
                <div className="text-4xl font-bold text-sky-600 mb-2" data-id="element-367">
                  {stat.value}
                </div>
                <div className="text-slate-600" data-id="element-368">{stat.label}</div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Story */}
      <section className="py-16 bg-slate-50" data-id="element-369">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-370">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-371">
            <div data-id="element-372">
              <h2 className="text-3xl font-bold text-slate-900 mb-6" data-id="element-373">
                Наша історія
              </h2>
              <div className="space-y-4 text-slate-600 leading-relaxed" data-id="element-374">
                <p data-id="element-375">
                  Aqua Pools розпочав свою діяльність в Івано-Франківську з
                  простої ідеї — зробити якісні басейни та обладнання доступними
                  для кожного.
                </p>
                <p data-id="element-376">
                  За роки роботи ми виросли від невеликого магазину до
                  повноцінного центру, який пропонує не лише широкий асортимент
                  товарів, але й професійні послуги з монтажу та обслуговування.
                </p>
                <p data-id="element-377">
                  Сьогодні ми пишаємося тисячами задоволених клієнтів по всій
                  Україні, які довірили нам створення свого ідеального простору
                  для відпочинку.
                </p>
              </div>
            </div>
            <div className="relative" data-id="element-378">
              <img src="https://images.unsplash.com/photo-1575429198097-0414ec08e8cd?w=800" alt="Басейн" className="rounded-2xl shadow-xl" data-id="element-379" />
              <div className="absolute -bottom-6 -left-6 bg-sky-500 text-white p-6 rounded-2xl shadow-lg" data-id="element-380">
                <div className="text-3xl font-bold" data-id="element-381">5+</div>
                <div className="text-sky-100" data-id="element-382">років досвіду</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 bg-white" data-id="element-383">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-384">
          <div className="text-center mb-12" data-id="element-385">
            <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-386">
              Наші цінності
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-387">
              Принципи, якими ми керуємося у роботі з кожним клієнтом
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-388">
            {values.map((value, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} className="bg-slate-50 rounded-2xl p-8 text-center" data-id="element-389">
                <div className="w-16 h-16 bg-sky-100 rounded-2xl flex items-center justify-center mx-auto mb-6" data-id="element-390">
                  <value.icon className="w-8 h-8 text-sky-600" data-id="element-391" />
                </div>
                <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-392">
                  {value.title}
                </h3>
                <p className="text-slate-600" data-id="element-393">{value.description}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16 bg-slate-50" data-id="element-394">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-395">
          <div className="text-center mb-12" data-id="element-396">
            <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-397">
              Чому обирають нас
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-398">
            {[{
            icon: TruckIcon,
            title: 'Швидка доставка',
            text: 'Відправляємо замовлення в день оформлення'
          }, {
            icon: ShieldCheckIcon,
            title: 'Офіційна гарантія',
            text: 'Гарантія виробника на все обладнання'
          }, {
            icon: UsersIcon,
            title: 'Експертна підтримка',
            text: 'Допомагаємо з вибором та консультуємо'
          }].map((item, index) => <div key={index} className="flex items-start gap-4 bg-white rounded-xl p-6 shadow-md" data-id="element-399">
                <div className="w-12 h-12 bg-sky-100 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-400">
                  <item.icon className="w-6 h-6 text-sky-600" data-id="element-401" />
                </div>
                <div data-id="element-402">
                  <h3 className="font-semibold text-slate-900 mb-1" data-id="element-403">
                    {item.title}
                  </h3>
                  <p className="text-sm text-slate-600" data-id="element-404">{item.text}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-gradient-to-br from-sky-500 to-cyan-600 text-white" data-id="element-405">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-406">
          <h2 className="text-3xl font-bold mb-4" data-id="element-407">Готові почати?</h2>
          <p className="text-xl text-sky-100 mb-8" data-id="element-408">
            Зв'яжіться з нами — допоможемо підібрати ідеальне рішення для вашого
            басейну чи сауни
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-409">
            <a href="https://t.me/aquapools_if" target="_blank" rel="noopener noreferrer" data-id="element-410">
              <Button size="lg" variant="secondary" leftIcon={<SendIcon className="w-5 h-5" data-id="element-412" />} className="bg-white text-sky-600 hover:bg-sky-50 w-full sm:w-auto" data-id="element-411">
                Написати в Telegram
              </Button>
            </a>
            <Link to="/catalog" data-id="element-413">
              <Button size="lg" variant="outline" className="border-white/30 text-white hover:bg-white/10 w-full sm:w-auto" data-id="element-414">
                Перейти в каталог
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </main>;
}